export const isProductionEnvironment = () => process.env.NODE_ENV === 'production';

export const isBrowserEnv = () => typeof window !== 'undefined';
